export const POPOVER_MODE_AUTO = 'auto' as const;
export const POPOVER_MODE_MANUAL = 'manual' as const;

export const POPOVER_MODES = {
  [POPOVER_MODE_AUTO]: 'Auto',
  [POPOVER_MODE_MANUAL]: 'Manual',
} as const;

export type PopoverMode = keyof typeof POPOVER_MODES;

export const isPopoverMode = (value: unknown): value is PopoverMode =>
  typeof value === 'string' && Object.hasOwn(POPOVER_MODES, value);
